export { default } from './ManagedAccountActivitySummary';
